import { TranslateService } from '@ngx-translate/core';
import { Moment } from 'moment';

import { TabInfoBase } from 'app/buffer-graph/models/tab-info-base';
import { BufferChangeReason } from 'app/buffer-graph/models/buffer-change-reasons/buffer-change-reason';
import {ColumnSettingsBase} from "../../../slick-grid/models/column-settings-base";
import {ItemInfo} from "../item-info";

type Data = { reasons: BufferChangeReason[], startDate: Moment, endDate?: Moment, canSend: boolean, columns: ColumnSettingsBase[] };

export class BufferChangeReasonsTabInfo extends TabInfoBase<Data> {
    constructor(type: string, data: Data, itemInfo: ItemInfo, startDate: Moment, endDate: Moment, sharedGuid: string) {
        super('BufferChangeReasons', type, data, itemInfo, startDate, endDate, sharedGuid);
    }

    get id(): string {
        return BufferChangeReasonsTabInfo.id;
    }

    static readonly id = 'BCR';
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/buffer-change-reasons/buffer-change-reasons-tab-info.ts